export enum TaxTypeEnum {
  GRAVABLE = 1,
  ISR_RETENTION = 2,
  EXEMPT = 3,
  EXONERATED = 4,
  NO_GRAVABLE = 5,
}

const TaxTypeEnumLabels: Record<TaxTypeEnum, string> = {
  [TaxTypeEnum.GRAVABLE]: 'Gravable',
  [TaxTypeEnum.ISR_RETENTION]: 'Retención ISR',
  [TaxTypeEnum.EXEMPT]: 'Exento',
  [TaxTypeEnum.EXONERATED]: 'Exonerado',
  [TaxTypeEnum.NO_GRAVABLE]: 'No Gravable',
}

export const TaxTypeEnumOptions: ISelectNumber[] = [
  {
    value: TaxTypeEnum.GRAVABLE,
    label: TaxTypeEnumLabels[TaxTypeEnum.GRAVABLE],
  },
  {
    value: TaxTypeEnum.ISR_RETENTION,
    label: TaxTypeEnumLabels[TaxTypeEnum.ISR_RETENTION],
  },
  {
    value: TaxTypeEnum.EXEMPT,
    label: TaxTypeEnumLabels[TaxTypeEnum.EXEMPT],
  },
  {
    value: TaxTypeEnum.EXONERATED,
    label: TaxTypeEnumLabels[TaxTypeEnum.EXONERATED],
  },
  {
    value: TaxTypeEnum.NO_GRAVABLE,
    label: TaxTypeEnumLabels[TaxTypeEnum.NO_GRAVABLE],
  },
]

export const findTypeByValue = (value: number): ISelectNumber | undefined => {
  if (!value) return undefined
  return TaxTypeEnumOptions.find(option => option.value === value)
}
